class HiddenColumn {
  constructor(schema, table, column) {
    this._schema = schema; // string
    this._table = table; // string or null
    this._column = column; // string or null
  }

  static build(serverObj) {
    return new HiddenColumn(
      serverObj._schema,
      serverObj._table,
      serverObj._column,
    );
  }

  schema() {
    return this._schema;
  }

  table() {
    return this._table;
  }

  column() {
    return this._column;
  }
}

export default HiddenColumn;
